import { func, bool, string } from "prop-types";

import TaskItemName from "../TaskItemName";
import TaskItemAssignedPlanIcon from "../TaskItemAssignedPlanIcon";

const TaskItemNameFrame = ({ hasAssignedPlan, assignedPlanName, nameOnClick, name }) => (
  <div className="tw-ml-16px tw-flex tw-flex-1 tw-min-w-0 tw-items-center">
    <TaskItemAssignedPlanIcon show={hasAssignedPlan} planName={assignedPlanName} className="tw-mr-4px" />
    <TaskItemName
      onClick={nameOnClick}
      name={name}
      className="tw-grow tw-text-left tw-border-0 tw-bg-transparent enabled:hover:tw-underline"
    />
  </div>
);

TaskItemNameFrame.propTypes = {
  hasAssignedPlan: bool,
  assignedPlanName: string,
  nameOnClick: func.isRequired,
  name: string,
};

TaskItemNameFrame.defaultProps = {
  hasAssignedPlan: false,
  assignedPlanName: null,
  name: null,
};

export default TaskItemNameFrame;
